import type { Licitacion } from "@/types";

/**
 * Ficha oficial en el portal de Mercado Público.
 *
 * Sirve tanto para licitaciones como para Compras Ágiles: la API v2 entrega un
 * `links.detalle`, pero apunta a la propia API (`/v2/compra-agil/{codigo}`), no
 * a la publicación que ve una persona, así que la ficha pública se arma desde
 * el código en ambos mecanismos.
 */
export const mercadoPublicoUrl = (codigo: string) =>
  `https://www.mercadopublico.cl/Procurement/Modules/RFB/DetailsAcquisition.aspx?idlicitacion=${encodeURIComponent(codigo)}`;

export function formatTenderDate(value: string | null | undefined, withTime = false) {
  if (!value) return "No informado";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "No informado";
  return new Intl.DateTimeFormat("es-CL", {
    dateStyle: "medium",
    ...(withTime ? { timeStyle: "short" as const } : {}),
  }).format(date);
}

export async function shareTender(licitacion: Pick<Licitacion, "codigo" | "nombre">) {
  const url = mercadoPublicoUrl(licitacion.codigo);
  if (navigator.share) {
    await navigator.share({
      title: licitacion.nombre,
      text: `Licitación ${licitacion.codigo}`,
      url,
    });
    return "shared" as const;
  }
  await navigator.clipboard.writeText(url);
  return "copied" as const;
}
